import { gsap } from 'gsap';
import gsapCore from 'gsap/gsap-core';
import Scrolltrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(Scrolltrigger);
gsap.config({ nullTargetWarn: false, });

let menuWidth = $('.menu').width();
let headerWidth = $('header').outerWidth();

// 初期状態で.menuを非表示に
gsap.set('.menu', {
  left: '100%'
});

// メニューを閉じる関数
const closeMenu = () => {
  $('header').removeClass('active');
  $('.menu-trigger').removeClass('active');
  $('.menu-btn .text p').text('MENU');

  gsap.to('.menu', {
    left: '100%',
    duration: 0.3,
    ease: "power2.in"
  });
};

// ハンバーガーメニューボタンのクリックイベント
$('.menu-btn').on('click', function (e) {
  e.preventDefault();
  $('.menu-trigger').toggleClass('active');
  const menuText = $('.menu-btn .text p');
  let menuWidth = $('.menu').width();
  let headerWidth = $('header').outerWidth();
  let windowWidth = $(window).width();

  if ($('.menu-trigger').hasClass('active')) {
    gsap.to('.menu', {
      left: 0,
      duration: 0.3,
      ease: "power2.out"
    });
    menuText.text('CLOSE');
    $('header').addClass('active');
  } else {
    closeMenu();
  }
});

// アンカーリンクのクリックイベント
$('.jsScroll').on('click', function (e) {
  closeMenu();
});

// ウィンドウリサイズ時の処理
$(window).on('resize', function () {
  menuWidth = $('.menu').width();
  headerWidth = $('header').outerWidth();
});
